export const BEGIN_API_CALL = "BEGIN_API_CALL";
export const API_CALL_ERROR = "API_CALL_ERROR";

// Build Forms
export const SET_DROPPED = "SET_DROPPED";
export const UPDATE_DROPPED_ITEMS = "UPDATE_DROPPED_ITEMS";
export const SET_FORM_TITLE = "SET_FORM_TITLE";
export const SET_FORM_DESCRIPTION = "SET_FORM_DESCRIPTION";

export const REMOVE_DROP_ITEM = "REMOVE_DROP_ITEM";
export const SET_EDITING_MODE = "SET_EDITING_MODE";
export const UPDATE_FIELD = "UPDATE_FIELD";
export const DISABLE_EDITING_MODE = "DISABLE_EDITING_MODE";
export const UPDATE_EDIT_FORM = "UPDATE_EDIT_FORM";
export const UPDATE_ENTIRE_FORMS = "UPDATE_ENTIRE_FORMS";

// User
export const LOADING_USER = "LOADING_USER";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const API_USER_ERROR = "API_USER_ERROR";

// Templates
export const LOADING_TEMPLATES = "LOADING_TEMPLATES";
export const LOAD_TEMPLATES_SUCCESS = "LOAD_TEMPLATES_SUCCESS";
export const LOADING_TEMPLATE = "LOADING_TEMPLATE";
export const GET_TEMPLATE_SUCCESS = "GET_TEMPLATE_SUCCESS";
export const SAVE_TEMPLATE_SUCCESS = "SAVE_TEMPLATE_SUCCESS";
export const UPDATE_TEMPLATE_SUCCESS = "UPDATE_TEMPLATE_SUCCESS";
export const DELETE_TEMPLATE_SUCCESS = "DELETE_TEMPLATE_SUCCESS";
export const API_TEMPLATE_ERROR = "API_TEMPLATE_ERROR";

// Form Configurations
export const SET_FORM_CONFIG_TYPE = "SET_FORM_CONFIG_TYPE";
export const SET_FORM_INTEGRATE_TYPE = "SET_FORM_INTEGRATE_TYPE";
export const UPDATE_FORM_CONFIG = "UPDATE_FORM_CONFIG";
export const UPDATE_ENTIRE_FORM_CONFIG = "UPDATE_ENTIRE_FORM_CONFIG";

//Template Progress
export const SET_TEMPLATE_PROGRESS_TYPE = "SET_TEMPLATE_PROGRESS_TYPE";
export const UPDATE_TEMPLATE_PROGRESS_TYPE = "UPDATE_TEMPLATE_PROGRESS_TYPE";

//Reset
export const RESET_STATE = "RESET_STATE";

//Integration
export const SET_INTEGRATION_CONFIG_TYPE = "SET_INTEGRATION_CONFIG_TYPE";
export const ADD_WEBHOOK = "ADD_WEBHOOK";
export const REMOVE_WEBHOOK = "REMOVE_WEBHOOK";
